"use client";

import { useState, Suspense } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import HomeAutomation from "./HomeAutomation";
import ModulerKitchen from "./ModulerKitchen";
import SpaceOptimizingFurniture from "./SpaceOptimizingFurniture";
import CentralizedCleaning from "./CentralizedCleaning";
// import SolarPower from "./SolarPower";
import AmenitiesNav from "./AmenitiesNav"; // <- from above
import SkyGarden from "./SkyGarden";
import { ASSET_PREFIX } from "@/config";

const SolarPower = dynamic(() => import("./SolarPower"), {
  ssr: false,
  loading: () => <p className="text-gray-500">Loading...</p>,
});

const amenitiesData = [
  {
    key: "solar-power",
    title: "Solar Power ",
    subtitle: "Net Zero Willa",
    description: "",
    image: "/images/solar-power-amenities.webp",
    component: <SolarPower />,
  },
  {
    key: "sky-garden",
    title: "Sky Garden",
    subtitle: "Relax & Grow Space",
    description: "",
    image: "/images/sky-garden-amenities.webp",
    component: <SkyGarden />,
  },
  {
    key: "centralized-vacuum-system",
    title: "Centralized Vacuum System",
    subtitle: "Effortless Cleaning",
    description: "",
    image: "/images/centrailed-vaccum-system-amenities.webp",
    component: <CentralizedCleaning />,
  },
  {
    key: "home-automation",
    title: "Home Automation",
    subtitle: "Futuristic Living",
    description:
      "",
    image: "/images/home-automation-menities.webp",
    component: <HomeAutomation />,
  },
  {
    key: "space-optimizing-furniture",
    title: "Space Optimizing Furniture",
    subtitle: "Designed to Adapt",
    description:
      "",
    image: "/images/optimized-space-amenities.webp",
    component: <SpaceOptimizingFurniture />,
  },
  {
    key: "modular-kitchen",
    title: "Modular Kitchen, Wardrobe's, Light, Fan, AC's...",
    subtitle: "Move-In Essentials +Willa",
    description:
      "",
    image: "/images/modular-kitchen-amenities.webp",
    component: <ModulerKitchen />,
  },
];

export default function Ameneties() {
  const [activeTab, setActiveTab] = useState("solar-power");
  const activeAmenity = amenitiesData.find((item) => item.key === activeTab);

  return (
    <section className="w-[85%] mx-auto ">
      <div className="grid grid-cols-1 md:grid-cols-[35%_65%] lg:grid-cols-[25%_70%] justify-between gap-8">
        {/* Left: Nav */}
        <div>
          <AmenitiesNav
            amenitiesData={amenitiesData}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>

        {/* Right: Content */}
        <article className="relative" role="tabpanel" aria-live="polite">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
            >
              <h2 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] font-[600] mb-[20px] text-[#000]">
                {activeAmenity?.title}
              </h2>
              <h3 className="text-[22px] md:text-[24px] font-[600] mb-[15px] text-[#000]">
                {activeAmenity?.subtitle}
              </h3>
              <p className="text-gray-700 mb-[25px] leading-relaxed">
                {activeAmenity?.description}
              </p>
              <div className="group overflow-hidden rounded-[25px_25px_0_0]">
              {activeAmenity?.image && (
                <Image
                  src={`${ASSET_PREFIX}${activeAmenity.image}`}
                  alt={activeAmenity.title}
                  width={800}
                  height={400}
                  priority={activeTab === "solar-power"}
                  className="w-full h-[200px] sm:h-[250px] md:h-[350px] object-cover object-top rounded-[25px_25px_0_0] mb-0 group-hover:scale-105 transition-transform duration-500"
                />
              )}</div>

              <Suspense fallback={<p>Loading content...</p>}>
                {activeAmenity?.component}
              </Suspense>
            </motion.div>
          </AnimatePresence>
        </article>
      </div>
    </section>
  );
}
